import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQS = [
  {
    q: "How long does Company Registration take in India?",
    a: "For Private Limited Company Registration in India, 7–10 working days from document submission. LLP Registration takes 10–14 days. OPC Registration wraps up within a week in most cases.",
  },
  {
    q: "How do I check Company Name Availability on MCA?",
    a: "We run an MCA Name Availability check in RUN (Reserve Unique Name) and cross-verify against existing trademarks. ZOZO Venture's Name Check tool checks MCA name availability, matching .com/.in domains and Indian trademark registry — results within 24 hours.",
  },
  {
    q: "Is GST Registration mandatory for a new company?",
    a: "GST Registration is mandatory if your services turnover crosses ₹20L (₹10L for some states), goods turnover crosses ₹40L, you sell inter-state, or sell via e-commerce. We handle end-to-end GST Registration within 3–5 working days.",
  },
  {
    q: "Do you charge for the initial consultation?",
    a: "No. Your first consultation with a ZOZO specialist is completely free. You only pay once you choose to move forward with a service.",
  },
  {
    q: "Can you help only with specific services — not the whole bundle?",
    a: "Absolutely. Pick any combination — just Company Registration, just GST Registration, just banking, just the website. Bundles save money, but they are never mandatory.",
  },
  {
    q: "Which cities do you operate in?",
    a: "Pan-India. Our partner network covers every major metro and tier-2 city. Workspaces and in-person services are available across 25+ cities.",
  },
  {
    q: "What information do I need to register a company in India?",
    a: "Just a rough idea of your business and basic identity documents (PAN, Aadhaar, address proof) of directors. We guide you through Company Name Availability, MCA filings, DIN, DSC, PAN, TAN, GST and more on a single call.",
  },
  {
    q: "How is pricing decided?",
    a: "Service-wise transparent pricing. Government fees are billed at actuals with receipts. No hidden markups, no surprise invoices.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="border-b border-black/10 bg-[#F4F4F5]" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#EAB308]">
              [ 04 ] FAQ
            </p>
            <h2 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mt-4">
              Questions, answered.
            </h2>
            <p className="mt-5 text-black/70">
              Still unsure? Drop your question in the form below — a ZOZO
              advisor will get back within 24 hours.
            </p>
          </div>

          <div className="md:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-black/20"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-5 font-heading font-semibold text-lg text-left hover:no-underline hover:text-[#EAB308]">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-black/70 text-base leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
